import React from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-page">
      <div className="home-left">
        <div className="home-decorative-circle" />
        <div className="home-content">
          <p className="home-eyebrow">✦ Welcome to</p>
          <h1 className="home-logo">Kami<br />Cupid</h1>
          <p className="home-divider">— ✦ —</p>
          <p className="home-tagline">
            Where meaningful connections <br />
            <em>bloom into something beautiful</em>
          </p>
          <div className="home-buttons">
            <button className="btn-signup" onClick={() => navigate('/signup')}>
              Begin Your Journey
            </button>
            <button className="btn-login" onClick={() => navigate('/login')}>
              Sign In
            </button>
          </div>
          <p className="home-footer-text">💗 Thousands of love stories started here</p>
        </div>
      </div>
      <div className="home-right">
        <div className="home-card-stack">
          <div className="home-preview-card card-back">
            <div className="preview-card-inner">
              <div className="preview-avatar">👤</div>
              <p className="preview-name">Emma, 23</p>
              <p className="preview-bio">Bookworm & foodie 🍕</p>
            </div>
          </div>
          <div className="home-preview-card card-front">
            <div className="preview-card-inner">
              <div className="preview-avatar">👤</div>
              <p className="preview-name">Sophie, 25</p>
              <p className="preview-bio">Love hiking & coffee ☕</p>
            </div>
          </div>
          <div className="home-floating-badge badge-1">💘 It's a Match!</div>
          <div className="home-floating-badge badge-2">❤️ 2,400 Matches Today</div>
        </div>
      </div>
    </div>
  );
}

export default Home;